import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const StatusViewLogModalOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true,
  size: 'md'
};

@Component({
    templateUrl: './status-view-log.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusViewLogModal {
  constructor(private activeModal: NgbActiveModal) { }

  public closeModal() {
    this.activeModal.close();
  }
}
